
import * as vClickOutside from "v-click-outside";
export default {
  directives: {
    clickOutside: vClickOutside.directive,
  },
  data() {
    return {
      openedModal: false,
      formStatus: true,
      options: [
        {
          name: "logo",
          label: "Logo",
          type: "image",
          size: "126x42",
        },
      ],
    };
  },
  methods: {
    showModal() {
      this.openedModal = true;

      const element = document.documentElement;
      if (element) {
        element.classList.add("overflow-hidden");
      }
    },
    closeModal() {
      this.openedModal = false;

      const element = document.documentElement;
      if (element) {
        element.classList.remove("overflow-hidden");
      }
    },
  },
};
